module.exports = __webpack_public_path__ + "static/media/screen3.26b261a2.png";